import * as React from 'react';
import styled from 'styled-components';
import { Card, CardContent, CardTitle, Input, Textarea, IInputProps } from '../../Components';
import { MonografiaModel } from '../../Store';
import { format } from 'date-fns';

interface IProps {
  monografia: MonografiaModel;
}

const MonografiaContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 1rem;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;

const StyledInput = styled(Input) <IInputProps>`
  margin: 0;
`;

export const TccCard: React.FC<IProps> = ({ monografia }: IProps) =>
  <Card>
    <CardTitle>TCC</CardTitle>
    <CardContent>
      <MonografiaContainer>
        <StyledInput
          label="Título"
          disabled={true}
          value={monografia.titulo}
        />
        <Textarea
          label="Bibliografia"
          disabled={true}
          value={monografia.bibliografia}
        />
        {monografia.deposito &&
          monografia.deposito.dataDoDeposito &&
          <StyledInput
            label='Data do Depósito'
            disabled={true}
            value={format(monografia.deposito.dataDoDeposito, 'DD/MM/YYYY')}
          />
        }
      </MonografiaContainer>
    </CardContent>
  </Card>;
